import * as React from "react";
import {Modal} from "antd";
import locales from "../locales";
import HandleAlertsForm from "./HandleAlertsForm";
import {FinalizeItemAlertsRequest, ItemAlert} from "../api/dtos/dtos";

interface Props {
  alerts: ItemAlert[];
  onCancel: () => void;
  onSubmit: (request: FinalizeItemAlertsRequest) => void;
}

class HandleAlertsModal extends React.Component<Props, {}> {

  public render(): React.ReactNode {
    const {onCancel, alerts} = this.props;
    return (
      <Modal
        title={locales.handle_confirm}
        visible={alerts.length > 0}
        footer={null}
        onCancel={onCancel}
        destroyOnClose={true}
      >
        <HandleAlertsForm
          onFormCancel={onCancel}
          onFormSubmit={this.onSubmit}
        />
      </Modal>
    );
  }

  private onSubmit = (handledDate: string) => {
    const alertItemIds = this.props.alerts.map(a => a.id);
    this.props.onSubmit({
      handledDate,
      alertItemIds
    });
  }
}

export default HandleAlertsModal;


// WEBPACK FOOTER //
// ./src/alerts/HandleAlertsModal.tsx